import axios from "axios";

// Same-origin on the web ("/api"): the httpOnly cookie carries the session. An installed app (the Android
// build) is built with REACT_APP_API_BASE=https://pettycash.navylunar.com/api; its own origin is not the
// API's, so it keeps the token from /auth/login and signs every request with it instead.
export const API = process.env.REACT_APP_API_BASE || "/api";
export const NATIVE = /^https?:\/\//i.test(API);

const TOKEN_KEY = "pc_token";
export function getToken() { try { return NATIVE ? localStorage.getItem(TOKEN_KEY) : null; } catch { return null; } }
export function setToken(t) { try { if (!NATIVE) return; if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch {} }

export const api = axios.create({
  baseURL: API,
  withCredentials: !NATIVE,
  headers: { "Content-Type": "application/json" },
});
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

/** Downloads an API file (Excel / PDF). Web: fetched as a blob and saved. Installed app: the URL is opened
 *  (with a 60-second download token as ?dl=) so the system browser saves it — WebViews have no download manager. */
export async function downloadFile(path, params, filename) {
  const clean = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== "" && v != null));
  if (NATIVE) {
    // The system browser saves the file (a WebView has no download manager). That URL is kept by browser
    // history, the download manager and the server log, so it carries a 60-second token for this one route —
    // never the session token.
    const { data } = await api.post("/auth/download-token", { path });
    const qs = new URLSearchParams({ ...clean, dl: data.token }).toString();
    window.open(`${API}${path}?${qs}`, "_blank", "noopener");
    return;
  }
  const res = await api.get(path, { params: clean, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a"); a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
